import React, { FC } from 'react';
import { DeleteColorSwatchButtonProps } from './colorSwatchModalInterface';
import { DeleteButtonStyled, DeleteIconStyled } from './styled';

const DeleteColorSwatchButton: FC<DeleteColorSwatchButtonProps> = ({ colorSwatchId, label, handleDeleteColorSwatch }) => (
    <DeleteButtonStyled
        onClick={() => handleDeleteColorSwatch(colorSwatchId)}
        variant="text"
        disableRipple
    >
        <DeleteIconStyled size='small' />
        {label}
    </DeleteButtonStyled>
);

export default DeleteColorSwatchButton;
